<InactivityModal />
<div class="vh-100 d-flex flex-column overflow-hidden bg-gray">
  <HomeNavBar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top border-bottom w-100 p-0 m-0"
  ></HomeNavBar>

  <div class="container-fluid flex-grow-1 overflow-auto py-2 py-md-3">
    <div class="mx-0 pb-4">
              <div class="portal-tabs-card portal-tabs-strip bg-banner-gradient rounded mb-4">
  <div class="tabs-wrapper d-flex align-items-center px-2 py-1">
    <div class="scrollable-tabs flex-grow-1">
      <ul class="nav nav-tabs nav-justified w-100 border-0 text-xxs px-2 gap-0 portal-icon-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
            type="button"
            role="tab"
            aria-selected="false"
            @click="$router.push({ name: 'donation_campaigns' })"
          >
            <i class="bi bi-compass-fill"></i>
            <span class="d-inline d-lg-none">Explore</span>
            <span class="d-none d-lg-inline">Explore Campaigns</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
            type="button"
            role="tab"
            aria-selected="false"
            @click="$router.push({ name: 'my_donation_campaigns' })"
          >
            <i class="bi bi-kanban-fill"></i>
            <span class="d-inline d-lg-none">Campaign</span>
            <span class="d-none d-lg-inline">My Campaigns</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center active"
            type="button"
            role="tab"
            aria-selected="true"
          >
            <i class="bi bi-clock-history"></i>
            <span class="d-inline d-lg-none">History</span>
            <span class="d-none d-lg-inline">My Donation History</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>

<div v-if="is_loading" class="text-center py-5 w-100">
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 mb-0 text-muted text-xxs">Loading your donations...</p>
              </div>

              <div v-else>
                <div class="mb-3">
                  <div class="row g-2 g-sm-3 mb-3">
                    <div class="col-6 col-md-6 col-xl-3">
                      <div class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm">
                        <div class="d-flex flex-column align-items-center text-center gap-2 h-100">
                          <div class="dashboard-stat-icon dashboard-stat-icon-primary mx-auto mx-sm-0">
                            <i class="bx bx-money"></i>
                          </div>
                          <div class="flex-grow-1 w-100">
                            <div class="text-muted text-xxs lh-sm mb-1">Total Donated</div>
                            <div class="small fw-bold text-dark lh-1 text-break">{{ format_currency(total_donated_amount) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-md-6 col-xl-3">
                      <div class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm">
                        <div class="d-flex flex-column align-items-center text-center gap-2 h-100">
                          <div class="dashboard-stat-icon dashboard-stat-icon-success mx-auto mx-sm-0">
                            <i class="bx bx-check-circle"></i>
                          </div>
                          <div class="flex-grow-1 w-100">
                            <div class="text-muted text-xxs lh-sm mb-1">Completed</div>
                            <div class="small fw-bold text-dark lh-1">{{ completed_donations_count }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-md-6 col-xl-3">
                      <div class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm">
                        <div class="d-flex flex-column align-items-center text-center gap-2 h-100">
                          <div class="dashboard-stat-icon dashboard-stat-icon-warning mx-auto mx-sm-0">
                            <i class="bx bx-time-five"></i>
                          </div>
                          <div class="flex-grow-1 w-100">
                            <div class="text-muted text-xxs lh-sm mb-1">Pending</div>
                            <div class="small fw-bold text-dark lh-1">{{ pending_donations_count }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 col-md-6 col-xl-3">
                      <div class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm">
                        <div class="d-flex flex-column align-items-center text-center gap-2 h-100">
                          <div class="dashboard-stat-icon dashboard-stat-icon-purple mx-auto mx-sm-0">
                            <i class="bx bx-receipt"></i>
                          </div>
                          <div class="flex-grow-1 w-100">
                            <div class="text-muted text-xxs lh-sm mb-1">All Donations</div>
                            <div class="small fw-bold text-dark lh-1">{{ total_donations_count }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="donations.length" class="table-responsive organization-members-panel donation-history-panel">
                  <table id="donationHistoryTable" class="table table-sm align-middle table-striped table-borderless text-nowrap">
                    <thead class="btn-primary text-white">
                      <tr>
                        <th class="text-xxs fw-light text-center text-nowrap">No.</th>
                        <th class="text-xxs fw-light text-nowrap">Donor</th>
                        <th class="text-xxs fw-light text-center text-nowrap">Amount</th>
                        <th class="text-xxs fw-light text-center text-nowrap">Status</th>
                        <th class="text-xxs fw-light text-nowrap">Reference</th>
                        <th class="text-xxs fw-light text-center text-nowrap">Date</th>
                        <th class="text-xxs fw-light text-nowrap">Message</th>
                        <th class="text-xxs fw-light text-center text-nowrap">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(donation, index) in donations" :key="donation.id" class="border-bottom text-xxs">
                        <td class="text-center">
                            {{ index + 1 }}
                        </td>
                        <td class="text-nowrap">
                          <div class="fw-bold text-dark text-nowrap">{{ donation.donor_name || 'Anonymous' }}</div>
                        </td>
                        <td class="text-center">{{ format_currency(donation.amount) }}</td>
                        <td class="text-center">
                          <span
                            class="badge rounded text-capitalize text-xxs fw-normal px-3 py-2"
                            :class="get_donation_status(donation) === 'completed'
                              ? 'bg-success-subtle text-success'
                              : get_donation_status(donation) === 'pending'
                                ? 'bg-warning-subtle text-warning'
                                : get_donation_status(donation) === 'failed'
                                  ? 'bg-danger-subtle text-danger'
                                  : 'bg-secondary-subtle text-secondary'"
                          >
                            {{ get_donation_status(donation) }}
                          </span>
                        </td>
                        <td class="text-nowrap">{{ donation.payment_reference || '-' }}</td>
                        <td class="text-center">{{ format_date(get_donation_date(donation)) }}</td>
                        <td class="text-wrap">
                          <div class="text-truncate">{{ get_donation_message(donation) }}</div>
                        </td>
                        <td class="text-center">
                          <div v-if="can_show_certificate_actions(donation)" class="dropdown d-inline-block">
                            <button
                              class="btn btn-sm btn-light border-0 text-dark"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="bi bi-three-dots-vertical"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                              <li v-if="get_donation_status(donation) === 'completed' && !has_certificate(donation) ">
                                <button class="dropdown-item text-xxs" type="button" @click="open_generate_certificate_modal(donation)">
                                  Generate Certificate
                                </button>
                              </li>
                              <li v-if="has_certificate(donation)">
                                <button class="dropdown-item text-xxs" type="button" @click="download_certificate(donation)">
                                  Download Certificate
                                </button>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else class="text-center py-5">
                  <i class="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                  <div class="mb-1 text-xxs">No donation history yet</div>
                  <div class="small text-muted text-xxs">Your donations will appear here once available.</div>
                </div>
              </div>
    </div>
  </div>
</div>

<teleport to="body">
<div class="modal fade" id="generateCertificateModal" tabindex="-1" aria-labelledby="generateCertificateModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-sm">
      <div class="modal-header border-bottom-0 pb-0">
        <div>
          <h5 id="generateCertificateModalLabel" class="modal-title fw-bold">Generate Section 18A Certificate</h5>
          <div class="text-muted text-xxs mt-1">Enter the donor details required before generating this certificate.</div>
        </div>
        <button type="button" class="btn-close" aria-label="Close" @click="close_generate_certificate_modal()"></button>
      </div>

      <div class="modal-body pt-3">
        <div class="row g-3">
          <div class="col-12">
            <div class="border rounded p-3 h-100 bg-white">
              <div class="fw-bold text-dark mb-3">Donor Identity</div>

              <div class="mb-3">
                <label class="form-label text-xxs fw-bold">Donor Type</label>
                <select class="form-control text-xxs rounded" :class="{ 'is-invalid': certificate_form_errors.donor_type }" v-model="certificate_form.donor_type" @change="handle_certificate_donor_type_change()">
                  <option value="natural_person">Natural Person (Individual)</option>
                  <option value="company">Company / Close Corporation</option>
                  <option value="trust">Trust</option>
                </select>
                <div v-if="certificate_form_errors.donor_type" class="text-danger text-xxs mt-1">{{ certificate_form_errors.donor_type }}</div>
              </div>

              <div class="mb-3">
                <label class="form-label text-xxs fw-bold">ID / Registration Type</label>
                <select class="form-control text-xxs rounded" :class="{ 'is-invalid': certificate_form_errors.registration_type }" v-model="certificate_form.registration_type">
                  <option
                    v-for="option in certificate_registration_type_options"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
                <div v-if="certificate_form_errors.registration_type" class="text-danger text-xxs mt-1">{{ certificate_form_errors.registration_type }}</div>
              </div>

              <div class="mb-3">
                <label class="form-label text-xxs fw-bold">ID / Registration Number</label>
                <input type="text" class="form-control text-xxs rounded" :class="{ 'is-invalid': certificate_form_errors.registration_number }" v-model="certificate_form.registration_number" :inputmode="certificate_form.registration_type === 'foreign_passport' ? 'text' : 'numeric'" @input="handle_certificate_registration_number_input()" placeholder="Enter ID or registration number" />
                <div v-if="certificate_form_errors.registration_number" class="text-danger text-xxs mt-1">{{ certificate_form_errors.registration_number }}</div>
              </div>

              <div class="mb-3">
                <label class="form-label text-xxs fw-bold">Country of Issue</label>
                <select class="form-control text-xxs rounded" :class="{ 'is-invalid': certificate_form_errors.country_of_issue }" v-model="certificate_form.country_of_issue">
                  <option v-for="country in country_options" :key="country" :value="country">
                    {{ country }}
                  </option>
                </select>
                <div v-if="certificate_form_errors.country_of_issue" class="text-danger text-xxs mt-1">{{ certificate_form_errors.country_of_issue }}</div>
              </div>

              <div>
                <label class="form-label text-xxs fw-bold">SARS Tax Reference Number</label>
                <input type="text" class="form-control text-xxs rounded" :class="{ 'is-invalid': certificate_form_errors.sars_tax_reference_number }" v-model="certificate_form.sars_tax_reference_number" inputmode="numeric" maxlength="10" @input="handle_certificate_sars_tax_reference_number_input()" placeholder="10-digit income tax number" />
                <div v-if="certificate_form_errors.sars_tax_reference_number" class="text-danger text-xxs mt-1">{{ certificate_form_errors.sars_tax_reference_number }}</div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <div class="modal-footer border-top-0 pt-0">
        <button type="button" class="btn btn-light border text-xxs" @click="close_generate_certificate_modal()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary text-xxs" @click="submit_generate_certificate()" :disabled="is_generating_certificate">
          {{ is_generating_certificate ? 'Generating...' : 'Generate Certificate' }}
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

